import { cva } from "../../styled-system/css";

export const input = cva({
  base: {
    width: '100%',
    height: '36px',
    backgroundColor: 'surface.primary',
    borderColor: 'border.secondary',
    borderRadius: '8px',
    borderWidth: '1px',
    borderStyle: 'solid',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.03)',
    px: '12px',
    _placeholder: {
      color: 'text.placeholder',
    },
    _disabled: {
      backgroundColor: 'surface.disable',
      borderColor: 'border.secondary',
      color: 'text.secondary',
    },
  },
  variants: {
    semantic: {
      invalid: {
        borderColor: 'border.accentError',
        backgroundColor: '#FFEBEE',
      }
    }
  }
});

export const inputWithButtonContainer = cva({
  base: {
    position: 'relative',
  }
});

export const inputButton = cva({
  base: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: '8px',
    top: '0',
    height: '100%',
    _disabled: {
      color: 'text.disable',
    },
  },
  variants: {
    semantic: {
      danger: {
        color: 'text.accentError',
      }
    }
  }
});

export const inputWrapper = cva({
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  }
});

export const inputLabel = cva({
  base: {
    fontSize: '16px',
    color: 'text.primary',
    fontWeight: '400',
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  }
});

export const requiredFieldLabel = cva({
  base: {
    fontSize: '14px',
    color: 'text.accentError',
    fontWeight: '400',
  }
});

export const nonRequiredFieldLabel = cva({
  base: {
    fontSize: '14px',
    color: 'text.secondary',
    fontWeight: '400',
  }
});

export const validationMessageLabel = cva({
  base: {
    fontSize: '12px',
    color: 'text.secondary',
    fontWeight: '400',
  },
  variants: {
    semantic: {
      invalid: {
        color: 'text.accentError',
      }
    }
  }
})

export const description = cva({
  base: {
    fontSize: '14px',
    color: 'text.secondary',
    fontWeight: '400',
  }
});

export const checkbox = cva({
  base: {
    display: 'flex',
    width: '20px',
    height: '20px',
    borderRadius: '4px',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'surface.primary',
    border: '1px solid',
    borderColor: 'border.secondary',
    color: 'text.disable',
    position: 'relative',
    '&[data-checked]': {
      backgroundColor: 'surface.accentPrimary',
      color: 'text.inverse',
    },
    '&[data-indeterminate]': {
      backgroundColor: 'surface.accentPrimary',
      color: 'text.inverse',
    }
  }
});

export const checkboxField = cva({
  base: {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
  }
});

export const radio = cva({
  base: {
    width: '16px',
    height: '16px',
    appearance: 'none',
    borderRadius: '50%',
    border: '1px solid',
    borderColor: 'border.secondary',
    backgroundColor: 'surface.primary',
    display: 'grid',
    placeItems: 'center',
    position: 'relative',
    '&::after': {
      content: '""',
      width: '6px',
      height: '6px',
      borderRadius: '50%',
      backgroundColor: 'transparent',
      transition: 'background-color 0.2s ease',
    },
    '&:checked': {
      backgroundColor: 'surface.accentPrimary',
      borderColor: 'surface.accentPrimary',
    },
    '&:checked::after': {
      backgroundColor: 'white',
    },
    '&:focus-visible': {
      outline: '2px solid var(--colors-surface-accentPrimary)',
      outlineOffset: '2px',
    },
  },
});
